import ActionsForm from '@/shared/mixins/actionsForm'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import chartTotalCost from './components/chartTotalCost/chartTotalCost.vue'
import searchTotalCost from './components/searchTotalCost/searchTotalCost.vue'

export default {
  name: 'Reports',
  mixins: [ActionsForm, ExpenseMixin],
  components: {AutocompleteZ, searchTotalCost, chartTotalCost},
  data () {
    return {
      formSearch: {}
    }
  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/totalCost/totalCost.js